// extracted by mini-css-extract-plugin
export default {"popup":"ModalPortfolio_popup__dlvZe","box_close_icon":"ModalPortfolio_box_close_icon__nzzcj","close_icon":"ModalPortfolio_close_icon__9pC86"};